export const PaycardType = {
  Digital: "digital",
  Physical: "physical",
} as const;

export type PaycardType = (typeof PaycardType)[keyof typeof PaycardType];
